<template>  
  <div>  
    <van-tabbar   
      class="ActionBar-title"   
      fixed   
      border   
      placeholder   
      safe-area-inset-bottom   
      v-model="active"   
      @change="onChange">  
      
      <van-tabbar-item 
        class="ActionBar-title1" 
        @click="goToPage('/home')" 
        icon="wap-home"
      >首页</van-tabbar-item>  
      
      <van-tabbar-item 
        class="ActionBar-title1" 
        @click="goToPage('/goodsBar')" 
        icon="column"
      >商品</van-tabbar-item>  
      
      <van-tabbar-item 
        class="ActionBar-title1" 
        @click="goToPage('/order')" 
        icon="column"
      >订单</van-tabbar-item>  
      
      <van-tabbar-item 
        class="ActionBar-title1" 
        @click="goToPage('/test')" 
        icon="column"
      >测试</van-tabbar-item> 
      
      <van-tabbar-item 
        class="ActionBar-title1" 
        @click="goToPage('/test1')" 
        icon="column"
      >开单</van-tabbar-item>  
      
      <van-tabbar-item 
        class="ActionBar-title1" 
        @click="goToPage('/warehousebar')" 
        icon="column"
      >库管</van-tabbar-item>  
      
      <van-tabbar-item 
        class="ActionBar-title1" 
        @click="goToPage('/my')" 
        icon="manager"
      ><span>我的</span></van-tabbar-item>  
    </van-tabbar>  
  </div>  
</template>  

<script>  
export default {  
  name: 'AppTabbar',  
  data() {  
    return {  
      active: 0,  
    };  
  },  
  methods: {  
    onChange(index) {  
      console.log(index);  
      this.active = index;
    },
    goToPage(path) {
      this.$router.push(path);
    }
  },  
};  
</script>  

<style scoped lang="less">  
:root {  
  --van-tabbar-item-active-color: #ff9854 !important; /* Active color for the tabbar items */  
  --van-tabbar-item-font-size: 30px !important; /* Font size for the tabbar items */  
}  

.ActionBar-title1 {  
  font-size: var(--van-tabbar-item-font-size); /* Use the active font size variable */  
}  
</style>